import { State } from "../types/state";

const action = (state: State) => {
  state.autosCoordinates = {};
};

export default action;
